"use strict";

exports.__esModule = true;
exports.alignPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var alignDirection = _propTypes.default.oneOf(['start', 'end']);
var alignPropType = exports.alignPropType = _propTypes.default.oneOfType([alignDirection, _propTypes.default.shape({
  sm: alignDirection
}), _propTypes.default.shape({
  md: alignDirection
}), _propTypes.default.shape({
  lg: alignDirection
}), _propTypes.default.shape({
  xl: alignDirection
}), _propTypes.default.shape({
  xxl: alignDirection
}), _propTypes.default.object]);